import { MessageType } from "./messageTypes";
import { AlertCircle, AlertTriangle, CheckCircle, HelpCircle } from "lucide-react";

export const MessagesIconClass = {
    [MessageType.None]: 'green',
    [MessageType.Success]: 'green',
    [MessageType.Error]: 'red',
    [MessageType.Warning]: 'orange',
    [MessageType.Information]: 'blue',
    [MessageType.Question]: 'blue',
}

export const MessagesIcons = {
    [MessageType.None]: null,
    [MessageType.Error]: AlertTriangle,
    [MessageType.Information]: AlertCircle,
    [MessageType.Success]: CheckCircle,
    [MessageType.Warning]: AlertCircle,
    [MessageType.Question]: HelpCircle,
};